/* eslint-disable react/no-danger */

import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom/';

// Components:
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

// Style and Icons:
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import muiTheme from 'theme';

// Utils:
import { createMarkup } from 'utilities/utils';
import { TopicDrawerNavigationContext } from 'utilities/topicConfigContext';

const styles = {
    '&.Mui-selected': {
        color: muiTheme.palette.secondary.main,
    },
    '&.MuiListItemText-root': {
        color: muiTheme.palette.secondary.main,
    },
};

export default function TopicsDrawer({ routerParams, hamburgerLinks }) {
    // // Router Params // //
    const { theme, tab } = routerParams;

    // Context:
    const topicDrawerContext = useContext(TopicDrawerNavigationContext);

    // // State // //
    const [state, setState] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    // // Methods // //
    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    // Method to extract href and title from link content stored in the database
    const linkParser = (link) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(link, 'text/html');
        const aTag = doc.querySelector('a');
        return { href: aTag.href, title: aTag.textContent };
    };

    // // Sub Components // //
    const themeTabsList = (topicTheme) => (
        <>
            {topicTheme.tabs.map((themeTab) => {
                const { topicUrlPath } = topicDrawerContext;
                const { themePath } = topicTheme;
                const { tabTitle, tabPath } = themeTab;

                return (
                    <ListItemButton
                        key={tabPath}
                        component={Link}
                        to={`/${topicUrlPath}/${themePath}/${tabPath}`}
                        sx={{ padding: 0, paddingLeft: '4rem' }}
                    >
                        <ListItemText
                            primary={
                                <span
                                    dangerouslySetInnerHTML={createMarkup(
                                        tabTitle
                                    )}
                                />
                            }
                            sx={tabPath === tab ? styles : { color: 'black' }}
                        />
                    </ListItemButton>
                );
            })}
        </>
    );

    const topicThemesList = (currentTopic) => (
        <>
            <ListItemButton
                component={Link}
                to={`/${currentTopic.topicUrlPath}`}
            >
                <ListItemText primary={currentTopic.topicTitle} sx={styles} />
            </ListItemButton>

            {currentTopic?.themes?.map?.((topicTheme) => {
                const { themePath, themeTitle, defaultTabPath } = topicTheme;

                return (
                    <List key={themePath} component="div" disablePadding>
                        <ListItemButton
                            component={Link}
                            to={`/${currentTopic.topicUrlPath}/${themePath}/${defaultTabPath}`}
                            sx={{ padding: 0, paddingLeft: '2rem' }}
                        >
                            <ListItemText
                                sx={themePath === theme ? styles : null}
                                primary={themeTitle}
                            />
                        </ListItemButton>
                        {theme === themePath ? themeTabsList(topicTheme) : null}
                    </List>
                );
            })}
        </>
    );

    const list = (anchor) => (
        <div
            className="topics-drawer-anchor-div"
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                <ListItemButton component={Link} to="/">
                    <ListItemText primary={'Home'} />
                </ListItemButton>
                {hamburgerLinks.map((link) => (
                    <a
                        key={link.id}
                        href={linkParser(link.content).href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="topic-drawer-link"
                    >
                        <ListItemButton>
                            {linkParser(link.content).title}
                        </ListItemButton>
                    </a>
                ))}
            </List>
            <Divider />
            <List>
                {topicDrawerContext && topicThemesList(topicDrawerContext)}
            </List>
        </div>
    );

    // // Render // //
    return (
        <>
            <Button
                onClick={toggleDrawer('left', true)}
                color="inherit"
                aria-label="open drawer"
            >
                <MenuRoundedIcon className="menu-icon" />
            </Button>
            <SwipeableDrawer
                anchor={'left'}
                open={state.left}
                onClose={toggleDrawer('left', false)}
                onOpen={toggleDrawer('left', true)}
            >
                {list('left')}
            </SwipeableDrawer>
        </>
    );
}
